"use client";
// Full-width signed-out pages (register, privacy policy, invoice/gate pass lookup).
import { useAuth } from "context/UseContext";
import { PlainLayout } from "layouts/Auth";
import { Navigate, OutletProvider } from "lib/router";

export default function Layout({ children }) {
  const { user } = useAuth();
  if (user) return <Navigate to="/dashboard" />;
  return (
    <OutletProvider outlet={children}>
      <PlainLayout />
    </OutletProvider>
  );
}
